// extracted by mini-css-extract-plugin
export default {"brandImage":"Brand_brandImage__Y4Jqf","brand":"Brand_brand__4irdL"};